import { render, staticRenderFns } from "./Scene18.vue?vue&type=template&id=45af2dce&scoped=true"
import script from "./Scene18.vue?vue&type=script&lang=js"
export * from "./Scene18.vue?vue&type=script&lang=js"
import style0 from "./Scene18.vue?vue&type=style&index=0&id=45af2dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af2dce",
  null
  
)

export default component.exports